<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-apps-fill`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M20 26a2 2 0 012 2v14a2 2 0 01-2 2H6a2 2 0 01-2-2V28a2 2 0 012-2h14zm21.882 0c1.17 0 2.118.948 2.118 2.118v13.764c0 1.17-.948 2.118-2.118 2.118H28.118A2.118 2.118 0 0126 41.882V28.118c0-1.17.948-2.118 2.118-2.118h13.764zM40 30H30v10h10V30zM20 4a2 2 0 012 2v14a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h14zm22 0a2 2 0 012 2v14a2 2 0 01-2 2H28a2 2 0 01-2-2V6a2 2 0 012-2h14z"/></svg>
</template>
<script>

export default {
  name: 'IconAppsFill',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
